"use strict";

exports.__esModule = true;
exports.WorkdayRangeSelector = void 0;
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _icons = require("@blueprintjs/icons");
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireWildcard(require("react"));
var _dateFnsLocaleMapping = require("../../../Utils/dateFnsLocaleMapping");
var _customDatePickerShortcuts = require("../../../Utils/customDatePickerShortcuts");
var _dynamicMomentLocaleImports = require("../../../Utils/dynamicMomentLocaleImports");
var _utils = require("../../Calendar/utils");
var _Translator = require("../../Core/Translator");
var _excluded = ["futureDates", "placeholder", "minDate", "maxDate", "selected", "onSelect", "disabled"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var localeKey = localStorage.getItem("vi-locale-key") || "en-us";
(0, _dynamicMomentLocaleImports.importMomentLocales)(localeKey);

/**
 * Allows a user to select a range of workdays from a popup calendar.
 */

var WorkdayRangeSelector = exports.WorkdayRangeSelector = function WorkdayRangeSelector(props) {
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  var _useState = (0, _react.useState)(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useState2 = (0, _react.useState)(props.selected),
    selected = _useState2[0],
    setSelected = _useState2[1];
  function handleChange(selectedDates) {
    var startDate = selectedDates[0],
      endDate = selectedDates[1];
    var onSelect = props.onSelect;
    setSelected([startDate, endDate]);

    // don't emit change or close if the user hasn't selected both start and end values
    if (startDate && endDate) {
      onSelect([startDate, endDate]);
      setIsOpen(false);
    }
  }
  function renderLabel() {
    var _toDateString = (0, _utils.toDateString)(selected),
      startDate = _toDateString[0],
      endDate = _toDateString[1];
    return startDate && endDate ? startDate === endDate ? (0, _moment["default"])(startDate).format("LL") : translate("WorkdayRangeSelector.rangeValue", "{startDate} to {endDate}", {
      startDate: (0, _moment["default"])(startDate).format("LL"),
      endDate: (0, _moment["default"])(endDate).format("LL")
    }) : placeholder || translate("WorkdayRangeSelector.placeholder", "Select Workdays");
  }
  (0, _react.useEffect)(function () {
    if (JSON.stringify(props.selected) !== JSON.stringify(selected)) {
      setSelected(props.selected);
    }
  }, [props.selected]);
  var futureDates = props.futureDates,
    placeholder = props.placeholder,
    minDate = props.minDate,
    _props$maxDate = props.maxDate,
    maxDate = _props$maxDate === void 0 ? (0, _utils.endOfCurrentDay)() : _props$maxDate,
    _selected = props.selected,
    _onSelect = props.onSelect,
    disabled = props.disabled,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var min = minDate || (0, _utils.getMinDate)();
  var max = futureDates ? _customDatePickerShortcuts.nextSixMonths : maxDate;
  var isEndGreaterThanMax = Array.isArray(selected) && selected[1] && (0, _utils.toDateMillis)(selected[1]) > (0, _utils.toDateMillis)(max);

  // Hack to handle blueprint goodies for past 6 months ..etc
  if (isEndGreaterThanMax) {
    selected[1] = max;
  }
  var shortcuts = [{
    label: translate("WorkdayRangeSelector.Today", "Today"),
    dateRange: [_customDatePickerShortcuts.today, _customDatePickerShortcuts.today]
  }, {
    label: translate("WorkdayRangeSelector.Yesterday", "Yesterday"),
    dateRange: [_customDatePickerShortcuts.yesterday, _customDatePickerShortcuts.yesterday]
  }, {
    label: translate("WorkdayRangeSelector.PastWeek", "Past week"),
    dateRange: [_customDatePickerShortcuts.oneWeekAgo, _customDatePickerShortcuts.today]
  }, {
    label: translate("WorkdayRangeSelector.PastMonth", "Past month"),
    dateRange: [_customDatePickerShortcuts.oneMonthAgo, _customDatePickerShortcuts.today]
  }, {
    label: translate("WorkdayRangeSelector.PastThreeMonths", "Past 3 months"),
    dateRange: [_customDatePickerShortcuts.threeMonthsAgo, _customDatePickerShortcuts.today]
  }, {
    label: translate("WorkdayRangeSelector.PastSixMonths", "Past 6 months"),
    dateRange: [_customDatePickerShortcuts.sixMonthsAgo, _customDatePickerShortcuts.today]
  }, {
    label: translate("WorkdayRangeSelector.PastYear", "Past year"),
    dateRange: [_customDatePickerShortcuts.oneYearAgo, _customDatePickerShortcuts.today]
  }, {
    label: translate("WorkdayRangeSelector.PastTwoYears", "Past 2 years"),
    dateRange: [_customDatePickerShortcuts.twoYearsAgo, _customDatePickerShortcuts.today]
  }];
  var futureDatesShortcuts = [{
    label: translate("WorkdayRangeSelector.NextSixMonths", "Next Six Months"),
    dateRange: [_customDatePickerShortcuts.today, _customDatePickerShortcuts.nextSixMonths]
  }, {
    label: translate("WorkdayRangeSelector.NextThreeMonths", "Next Three Months"),
    dateRange: [_customDatePickerShortcuts.today, _customDatePickerShortcuts.nextThreeMonths]
  }, {
    label: translate("WorkdayRangeSelector.NextMonth", "Next Month"),
    dateRange: [_customDatePickerShortcuts.today, _customDatePickerShortcuts.nextMonth]
  }, {
    label: translate("WorkdayRangeSelector.NextWeek", "Next Week"),
    dateRange: [_customDatePickerShortcuts.today, _customDatePickerShortcuts.nextWeek]
  }, {
    label: translate("WorkdayRangeSelector.Tomorrow", "Tomorrow"),
    dateRange: [_customDatePickerShortcuts.tomorrow, _customDatePickerShortcuts.tomorrow]
  }];
  if (futureDates) {
    shortcuts.unshift.apply(shortcuts, futureDatesShortcuts);
  }
  return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    isOpen: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    content: /*#__PURE__*/_react["default"].createElement(_datetime.DateRangePicker, _extends({
      allowSingleDayRange: true,
      minDate: min,
      maxDate: max,
      value: selected,
      onChange: handleChange,
      shortcuts: shortcuts,
      locale: _dateFnsLocaleMapping.dateFnsLocaleKeyMapping[localeKey]
    }, extra))
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "WorkdayRangeSelectorButton",
    style: {
      marginLeft: "15px"
    },
    icon: _icons.IconNames.CALENDAR,
    onClick: function onClick() {
      return setIsOpen(true);
    },
    text: /*#__PURE__*/_react["default"].createElement(_core.Text, {
      ellipsize: true
    }, renderLabel()),
    disabled: disabled
  }));
};